import * as React from 'react';
import { LoadOptions } from 'app/types-shared';
import { CodeSinglePicker } from 'app/area/codetable/common';
import { ScreenPickerProps, ScreenPicker } from 'app/area/codetable/item/screen-renderer/types';
import { codetableOptionsIds } from 'app/area/codetable/item/screen-renderer/screen-pickers/constants';
import { ReadOnlyType } from 'app/area/codetable/item/types';
import { configurationAlreadyExistsKey } from 'app/area/indicator-factors/constants';
import { CodetableTranslation } from 'app/area/codetable/constants';
import { manageOptionsButton } from 'app/area/shared/manage-options';
import { CodeComplexValue } from 'app/area/shared/codetable/types';

export type RecurrenceProps = ScreenPickerProps & {
  recurrenceLabel: (translation: CodetableTranslation) => string;
  isRecurrenceRequired?: boolean;
};

export const Recurrence = (props: RecurrenceProps) => {

  const { codeItem, updateByKey, resetValidation, codetableOptions, loadCodetableOptions, translation, validation, readOnlyConfig,
    recurrenceLabel, breadcrumbs, isRecurrenceRequired } = props;

  const onChange = (value: CodeComplexValue<number>) => {
    resetValidation(ScreenPicker.recurrence);
    if (validation.category && validation[configurationAlreadyExistsKey]) {
      resetValidation(ScreenPicker.category);
      resetValidation(configurationAlreadyExistsKey);
    }
    updateByKey(ScreenPicker.recurrence, value);
  };

  const onLoadOptions = (id: string, loadOptionsParams: LoadOptions) => {
    loadCodetableOptions(id, codetableOptionsIds.recurrence, loadOptionsParams);
  };

  const codeOptions = (!!codetableOptions.recurrence && codetableOptions.recurrence.codes || []) as CodeComplexValue<number>[];

  const recurrenceValidation = !!validation && !!validation.recurrence ? validation.recurrence : undefined;

  const readOnly = readOnlyConfig && readOnlyConfig[ReadOnlyType.all];

  const codetableId = codetableOptionsIds[ScreenPicker.recurrence];

  const extraFooterButton = manageOptionsButton(translation.manage_options, codetableId, breadcrumbs);

  const required = isRecurrenceRequired ?? !readOnly;

  return <CodeSinglePicker
    id={ScreenPicker.recurrence}
    label={recurrenceLabel?.(translation) ?? translation.recurrence}
    valueItem={codeItem && codeItem.recurrence}
    searchRequired={false}
    required={required}
    readOnly={readOnly}
    options={codeOptions}
    fetchingOptions={codetableOptions.recurrence && codetableOptions.recurrence.fetching}
    extraFooterButton={extraFooterButton}
    translation={translation}

    onLoadOptions={onLoadOptions}
    onChange={onChange}
    validation={recurrenceValidation}
  />;
};
